/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import ReportCheckInEvent from '../../event/MonthlyReportEvent'

const ReportCheckInsState = Record({
  search_date: null,
  search_hotel_id: null,
  age0m: 0,
  age0w: 0,
  age10m: 0,
  age10w: 0,
  age20m: 0,
  age20w: 0,
  age30m: 0,
  age30w: 0,
  age40m: 0,
  age40w: 0,
  age50m: 0,
  age50w: 0,
  age60m: 0,
  age60w: 0,
  age70m: 0,
  age70w: 0,
  age_total_m: 0,
  age_total_w: 0,
  occupations: [],
  nations: []
})

class ReportCheckInsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReportCheckInsState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReportCheckInEvent.checkInMonthChanged:
        return state.merge(payload)

      default:
        return state
    }
  }
}

export default new ReportCheckInsStore()
